// extracted by mini-css-extract-plugin
export default {"focusRing":"src-signer-app-signer-experience-dig-workaround-module__focusRing--3IARC"};